import { includes } from "lodash";
import { isSuperAdmin } from "@linkfluence/models/role";
import { Project } from "@radarly/models/project";
import { useCanAccessProject } from "./useCanAccessProject";
import { useCanAccessProjectFromCurrentUserLevel } from "./useCanAccessProjectFromCurrentUserLevel";
import { useGetCurrentUserProjectData } from "./useGetCurrentUserProjectData";

function useCanAccessWorkspaceFromCurrentUserProjectData(
  projectId: number,
  workspaceId: number
) {
  const userProject = useGetCurrentUserProjectData(projectId);
  if (!userProject) {
    return false;
  }
  return (
    isSuperAdmin(userProject.role) ||
    includes(userProject.dashboardIds, workspaceId)
  );
}

export function useCanAccessWorkspace(project: Project, workspaceId: number) {
  const canAccessProject = useCanAccessProject(project);
  const canAccessProjectFromCurrentUserLevel = useCanAccessProjectFromCurrentUserLevel(
    project
  );
  const canAccessWorkspaceFromCurrentUserProjectData = useCanAccessWorkspaceFromCurrentUserProjectData(
    project?.id,
    workspaceId
  );
  if (!canAccessProject) {
    return false;
  }
  return (
    canAccessProjectFromCurrentUserLevel ||
    canAccessWorkspaceFromCurrentUserProjectData
  );
}
